import {
  CssBaseline,
  Grid,
  ScopedCssBaseline,
  ThemeProvider,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ReactNode } from 'react';
import GeoMobyBaseTheme from '../../../Style/GeoMobyBaseTheme';
import { ZIndexes } from '../../../util/ZIndexes';

export const useColumnMenus = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

export const TOP_PADDING = '15px';
export const BANNER_HEIGHT = 56;

export const SidebarAndMap = ({
  sidebar,
  banner,
  map,
}: {
  sidebar: ReactNode;
  banner?: ReactNode;
  map: ReactNode;
}) => {
  const columnView = useColumnMenus();
  return (
    <Grid container direction={'column'} sx={{ overflowX: 'hidden' }}>
      <Grid item container direction={columnView ? 'column-reverse' : 'row'}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          xl={3}
          height="100%"
          maxWidth={columnView ? '100% !important' : 'auto'}
        >
          <ThemeProvider theme={GeoMobyBaseTheme}>
            <CssBaseline />
            <ScopedCssBaseline>{sidebar}</ScopedCssBaseline>
          </ThemeProvider>
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8} xl={9} height="100%" bgcolor="background.paper">
          {banner && (
            <div
              style={{
                zIndex: ZIndexes.MAP_BANNER,
                width: '-webkit-fill-available',
                height: BANNER_HEIGHT,
                position: 'absolute',
              }}
            >
              {banner}
            </div>
          )}
          {map}
        </Grid>
      </Grid>
    </Grid>
  );
};
